import React from 'react';
import Switch from "react-switch";
import styled from "styled-components";

const Title = styled.span`
  font-size: 14px;
  color: #8f8f8f;
`;

const BooleanContainer = styled.div`
  width: 100%;
  text-align: center;
`;

const TitleAndSwitchBox = ({ title, value, onChange, isForEdit, isEnabled }) => {

    const handleValueChange = (newValue) => {
        if (isForEdit) {
            onChange(newValue);
        } else {
            return;
        }
    };

    return (
        <div
            style={{
                width: '100%'
            }}
        >
            {/* title */}
            <div
                style={{
                    width: '100%',
                    paddingLeft: '5px',
                    textAlign: 'left'
                }}
            >
                <Title>
                    {title}
                </Title>
            </div>
            {/* switch */}
            <div
                style={{
                    width: '100%',
                    marginTop: '5px'
                }}
            >
                <BooleanContainer>
                    {
                        isEnabled ?
                            <Switch
                                checked={value}
                                onChange={handleValueChange}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                onColor={"#52b640"}
                            />
                            :
                            <Switch
                                checked={value}
                                onChange={() => {}}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                onColor={"#008000"}
                            />
                    }
                </BooleanContainer>
            </div>
        </div>
    );
};

export default TitleAndSwitchBox;